import React, { useContext } from 'react';
import { IModifiersContext, ModifiersContext } from '../../../modifiersState/modifiersContext';
import { Checkbox } from 'antd';
import Text from 'components/Text/Text';

export const IsDisabledCheckbox: React.FC = () => {
	const { toggleIsDisabled, isDisabled, IDSelectedRestaurant } = useContext<IModifiersContext>(ModifiersContext);

	return (
		<Checkbox
			indeterminate={isDisabled === null}
			checked={!!isDisabled}
			onChange={toggleIsDisabled}
			disabled={!IDSelectedRestaurant}
			data-test="IsDisabledCheckbox">
			<Text translationNameSpace="listing" translationKey="modifierInStopLabel" asFragment={true} />
		</Checkbox>
	);
};
